import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AppsService } from "src/app/shared/services/apps.service";
declare const tinymce: any;
import { HttpClient } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";
import { NzModalService } from "ng-zorro-antd/modal";
// import { PipeTransform, Pipe } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-help-documentation",
  templateUrl: "./help-documentation.component.html",
  styleUrls: ["./help-documentation.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
// @Pipe({ name: 'safeHtml'})
export class HelpDocumentationComponent implements OnInit {
  model = "";
  maxUploadFileSize = 1000000;
  pagesLst;
  pgeid;
  sectnLst;
  selectdnav = { sctn_nm: "", dscptn_txt: "", sctn_id: "" };
  newselectdnav = { sctn_nm: "", dscptn_txt: "", sctn_id: "" };

  newCntent = false;
  files;
  value;
  contentHtml;
  init;
  checkcnt;
  length;
  temcnt;
  pageId;
  pgGrpNm;
  pageName;
  routerLinkVariable;
  USER_PERMISSIONS: any = {
    slct_in: 0,
    insrt_in: 0,
    updt_in: 0,
    dlte_in: 0,
    exprt_in: 0,
  };
  usrAcsErrMsg: boolean = false;
  constructor(
    public apiSrv: AppsService,
    private http: HttpClient,
    private sanitized: DomSanitizer,
    private modal: NzModalService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.pageId = params.pgeId;
    });
    this.routerLinkVariable = `/setup/helppge`;
  }
  onBack() {}

  ngOnInit() {
    this.init = {
      // SECURITY (audit obs #12 - Subresource Integrity, CWE-353):
      // TinyMCE is served from our own origin. Without base_url/suffix the
      // editor resolves its skins, themes, models and plugins relative to
      // wherever tinymce.min.js was loaded from - and if the `tinymce` global
      // is missing entirely, @tinymce/tinymce-angular injects
      // https://cdn.tiny.cloud/1/no-api-key/... at runtime. That is a
      // third-party script with no integrity check, injected by the framework
      // rather than by any tag in our source, so it is invisible to a grep for
      // <script src>. angular.json now loads tinymce.min.js from node_modules
      // (so the global exists) and copies the runtime to /assets/tinymce.
      // LICENSING (audit obs #10). TinyMCE 7 relicensed LGPL-2.1 -> GPL-2.0-or-later
      // and made the licence declaration explicit: 'gpl' is TinyMCE's own
      // documented value for running the free open-source build. It is a
      // DECLARATION, not a bypass - the commercial alternative is a paid key.
      //
      // The obligation is real and attaches here, because TinyMCE is JavaScript
      // shipped to every user's browser - that is distribution, even though a
      // server-side GPLv2 component would not be. It is kept as a separate,
      // unmodified bundle (angular.json `scripts[]` emits scripts.js; the app's
      // own code is in main.js) rather than compiled together with application
      // source, which is the ordinary way to stay on the right side of the
      // aggregation line. Do not import TinyMCE modules into application code.
      license_key: "gpl",
      base_url: "/assets/tinymce",
      suffix: ".min",
      height: 300,
      menubar: false,
      // TinyMCE 6 plugin names. The old list was written for the 5.4.2 CDN
      // build: `print`, `textcolor` and `paste` no longer exist as plugins in
      // 6.x (print was dropped, the other two moved into core), and naming a
      // plugin that does not exist logs an error and silently drops it.
      plugins: [
        "advlist autolink lists link image charmap preview anchor",
        "searchreplace visualblocks code fullscreen",
        "insertdatetime media table help wordcount quickbars",
      ],
      // TinyMCE 6 toolbar names: formatselect -> blocks, fontselect -> fontfamily.
      toolbar:
        "undo redo | blocks | bold italic backcolor forecolor fontfamily | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | help | image",
      // TinyMCE 6 renamed font_formats -> font_family_formats.
      font_family_formats:
        "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
      // TinyMCE 6 expects a Promise; the 5.x (blobInfo, success, failure)
      // signature is no longer called, so image upload was broken regardless.
      // The endpoint was also hardcoded to http://localhost:4903, which could
      // only ever have worked on one developer's machine - it now uses the
      // same origin as every other API call.
      images_upload_handler: (blobInfo, progress) =>
        new Promise<string>((resolve, reject) => {
          const data = new FormData();
          data.append(
            "imgData",
            "data:" + blobInfo.blob().type + ";base64," + blobInfo.base64()
          );

          const Http = new XMLHttpRequest();
          Http.open("POST", environment.origin + "apiv1/kb/page/imgsave", true);
          Http.withCredentials = true;

          Http.upload.onprogress = (e) => {
            if (progress && e.lengthComputable) {
              progress(Math.round((e.loaded / e.total) * 100));
            }
          };
          Http.onerror = () =>
            reject({
              message: "Image upload failed: network error",
              remove: true,
            });
          Http.onload = () => {
            if (Http.status < 200 || Http.status >= 300) {
              reject({ message: "HTTP Error: " + Http.status, remove: true });
              return;
            }
            let json;
            try {
              json = JSON.parse(Http.responseText);
            } catch (e) {
              reject({
                message: "Invalid JSON returned by image upload",
                remove: true,
              });
              return;
            }

            if (!json || typeof json.data != "string") {
              reject({
                message: "Invalid response from image upload",
                remove: true,
              });
              return;
            }
            resolve(json.data);
          };
          Http.send(data);
        }),
      setup: function (editor) {
        editor.on("click", function (e) {
          //   console.log('Editor was clicked');
          //   console.log(e)
          this.length = editor.contentDocument.body.innerText.length;
          //   console.log(length)
        });
        editor.on("change", function (e) {});
      },
      content_style:
        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    };
    this.getsection();
  }
  ngOnDestroy() {
    // Guarded: if the bundled tinymce script ever fails to load, an unguarded
    // reference to the global throws a ReferenceError and breaks teardown.
    if (typeof tinymce !== "undefined" && tinymce) {
      tinymce.remove();
    }
  }
  getPagesAll() {
    let rte = `kb/page`;
    this.apiSrv.get(rte).subscribe((res) => {
      //   //   console.log(res)
      this.pagesLst = res["data"];
    });
  }
  Addsection() {
    //   console.log("add new section");
    this.newCntent = true;
    this.selectdnav = { sctn_nm: "", dscptn_txt: "", sctn_id: "" };
  }
  getsection() {
    let rte = `kb/sections/${this.pageId}`;
    this.usrAcsErrMsg = false;
    this.apiSrv.get(rte).subscribe((res) => {
      if (res["status"] == 404) {
        this.usrAcsErrMsg = true;
      } else if (res["status"] == 200) {
        this.USER_PERMISSIONS = res["perm"][0];
        if (this.USER_PERMISSIONS.slct_in === 1) {
          //   //   console.log(res)
          this.sectnLst = res["data"];
          this.pgGrpNm = this.sectnLst[0].pge_grp_nm;
          this.pageName = this.sectnLst[0].pge_nm;
          this.selectedValue(this.sectnLst[0]);
        } else {
          this.usrAcsErrMsg = true;
        }
      } else {
      }
    });
  }
  selectedValue(sec) {
    this.selectdnav = sec;
    this.newCntent = false;
    if (this.selectdnav) {
      this.value = this.selectdnav.sctn_nm;
      this.contentHtml = this.sanitized.bypassSecurityTrustHtml(
        this.selectdnav.dscptn_txt
      );
    }
  }
  deleteSection() {
    this.modal.confirm({
      nzTitle: "Are you sure delete this section?",
      nzContent: `<b style="color: red;">${this.selectdnav.sctn_nm}</b>`,
      nzOkText: "Yes",
      // nzOkType: 'danger',
      nzOkDanger: true,
      nzOnOk: () => this.sectiondelete(),
      nzCancelText: "No",
      nzOnCancel: () => console.log("Cancel"),
    });
  }
  sectiondelete() {
    let rte = `kb/pages/sections/:sctn_id`;
    this.apiSrv.delete(rte).subscribe((res) => {
      //   //   console.log(res)
      this.getsection();
    });
  }
  editSection() {
    //   console.log(this.selectdnav)
    this.newCntent = true;
    this.checkcnt = this.selectdnav.dscptn_txt.length;
    //   console.log(this.checkcnt)
  }
  cancelcontent() {
    this.newCntent = false;
  }
  savecontent() {
    let data = this.selectdnav;
    //   console.log(data)

    if (data.sctn_id) {
      let rte = `kb/page/sections/` + data.sctn_id;
      this.apiSrv.update(data, rte).subscribe((res) => {
        //   //   console.log(res)
        this.getsection();
      });
    } else {
      data["pge_id"] = this.pageId;
      data["sqnce_id"] = this.sectnLst.length + 1;
      let rte = `kb/pages/` + this.pageId + `/sections`;
      this.apiSrv.create(data, rte).subscribe((res) => {
        //   //   console.log(res)
        this.getsection();
      });
    }
  }
}
